import { render, staticRenderFns } from "./checkRecord.vue?vue&type=template&id=4a5db0ac&scoped=true&"
import script from "./checkRecord.vue?vue&type=script&lang=js&"
export * from "./checkRecord.vue?vue&type=script&lang=js&"
import style0 from "./checkRecord.vue?vue&type=style&index=0&id=4a5db0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5db0ac",
  null
  
)

export default component.exports